export default [
  {
    title: '学习机课程名称',
    dataIndex: 'itvCourseName',
    forbidHide: true,
    width: 50,
    scopedSlots: { customRender: 'itvCourseName' }
  },
  {
    title: '年级',
    dataIndex: 'gradeName',
    forbidHide: true,
    width: 40
  },
  {
    title: '科目',
    dataIndex: 'subjectName',
    // forbidHide: true,
    width: 20
  },
  {
    title: '学期',
    dataIndex: 'periodName',
    forbidHide: true,
    width: 30
  },
  {
    title: '课程类型',
    dataIndex: 'classStyle',
    forbidHide: true,
    width: 30,
    customRender: text => {
      const obj = {
        1: '长线课',
        2: '短线课',
        3: '公开课'
      }
      return obj[text]
    }
  },
  {
    title: '体系',
    dataIndex: 'schemeName',
    forbidHide: true,
    width: 30
  },
  {
    title: '操作',
    // dataIndex: 'schemeName',
    forbidHide: true,
    scopedSlots: { customRender: 'action' },
    width: 50
  }
]